import React from "react";
import { ThemedListItemView } from "./view";
import { styles } from "./styles";

export class ThemedListItem extends React.Component {
  render() {
    return <ThemedListItemView {...this.props} styles={styles} />;
  }
}
